import React from 'react';
import { Avatar, useTheme } from '@mui/material';
import { CenteredFlexBox } from '../../../Components/FlexBox';
import ChairOutlinedIcon from '@mui/icons-material/ChairOutlined';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import CottageOutlinedIcon from '@mui/icons-material/CottageOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';
import DirectionsCarFilledRoundedIcon from '@mui/icons-material/DirectionsCarFilledRounded';
import { getForcedMessages } from '../../../i18n';

const Icons = {
  HOME: CottageOutlinedIcon,
  AUTO: DirectionsCarFilledRoundedIcon,
  HEALTH: LocalHospitalOutlinedIcon,
  FURNISHINGS: ChairOutlinedIcon,
  DEFAULT: WidgetsRoundedIcon,
};

const SegmentComponent = function SegmentComponent({ label, value }) {
  const theme = useTheme();
  const italianTerms = getForcedMessages('it');

  const Icon =
    Icons[
      Object.keys(italianTerms)?.find(
        (keyName) =>
          italianTerms[keyName]?.toUpperCase() === value?.toUpperCase()
      )
    ] || Icons.DEFAULT;

  return (
    <CenteredFlexBox gap="8px">
      <Avatar
        variant="rounded"
        sx={{
          ...theme.custom.bgAndColorStyle(
            theme.custom.stringToColor(value?.toUpperCase() || 'DEFAULT'),
            theme.palette.mode
          ),
          borderRadius: '8px',
        }}
      >
        <Icon sx={{ color: 'inherit', fontSize: '24px' }} />
      </Avatar>
      <CaptionValue
        valueStyle={{ fontWeight: 500 }}
        caption={label}
        value={value}
      />
    </CenteredFlexBox>
  );
};

export default SegmentComponent;
